import styled, { css } from 'styled-components'
import { Box, theme, Grid } from '@dasa-health/components-react'

export const Container = styled.div`
    width: 100vw;
    margin: 0 auto;
    padding-bottom: 2rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        max-width: calc(100vw - 9.375rem);
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        max-width: 54.5rem;
        padding-bottom: 4rem;
    }
`

export const GridLayout = styled.div`
    display: grid;
    margin: 1rem;
    grid-template:
        'texts image'
        'buttons image';

    @media screen and (max-width: ${theme.breakpoints[0]}) {
        grid-template:
            'texts image'
            'buttons buttons';
    }
`

export const TextsGrid = styled.div`
    grid-area: texts;
`
export const ImageGrid = styled.div`
    grid-area: image;
`
export const ButtonGrid = styled.div`
    grid-area: buttons;
`

export const TopicBox = styled(Grid)`
    padding: 1rem;
    margin-top: 1.875rem !important;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        padding: 0 1rem;
        margin-top: 1.25rem !important;
    }

    @media screen and (min-width: ${theme.breakpoints[2]}) {
        margin-top: 3.125rem !important;
    }
`

export const BoxTexts = styled(Box)`
    min-width: 12.688rem !important;
    max-width: 20.625rem !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 2.5rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        max-width: 18.125rem !important;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        width: 100%;
        min-width: 29.275rem !important;
    }

    @media screen and (max-width: ${theme.breakpoints[1]}) {
        padding-top: 0;
    }
`

export const TextBrand = styled.h1`
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.5rem;
    color: #161616;
    text-align: left;
`
export const Title = styled.h1`
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.995rem;
    text-align: left;
    text-transform: 'capitalize';

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.5rem;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        font-size: 2rem;
        font-weight: 700;
        line-height: 2.5rem;
    }
`

interface SubTitleProps {
    open: boolean
    shouldShowFade: boolean
}

export const SubTitle = styled.div<SubTitleProps>`
    font-size: 0.875rem;
    font-weight: 400;
    text-align: left;
    margin-top: 1rem;
    color: #161616;

    overflow: ${({ open }) => (open ? 'unset' : 'hidden')};
    max-height: ${({ open }) => (open ? 'unset' : '72px')};
    position: ${({ shouldShowFade }) => (shouldShowFade ? 'relative' : 'unset')};

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        max-width: 26.875rem;
    }

    ${({ shouldShowFade }) => css`
        ${shouldShowFade &&
        css`
            :after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 24px;
                background: linear-gradient(rgba(255, 255, 255, 0.001), white);
            }
        `}
    `};
`

export const SeeMore = styled.p`
    font-style: normal;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1rem;
    align-items: center;
    color: #0037ff;
    cursor: pointer;
    margin-bottom: 0.625rem;
`

export const Price = styled.p`
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.5rem;
    color: #161616;
    text-align: left;
    margin: 1.25rem 0 0;

    em {
        color: #ff4e33;
        font-style: inherit;
        font-size: 1rem;
        font-weight: 600;
    }
`

export const TagContainer = styled.div`
    display: flex;
    margin: 0.75rem 0;
    gap: 0.5rem;
`

export const PredictionTag = styled.p`
    font-weight: 400;
    line-height: 1.5rem;
    background: #ededed;
    padding: 0.25rem 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.875rem;
    white-space: nowrap;
    border-radius: 1.5rem;
`

export const Img = styled.img`
    width: 100%;
    max-width: 23.625rem;
    min-width: 8.125rem;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        max-width: 12.813rem;
        float: right;
    }

    @media screen and (min-width: 45rem) {
        position: relative;
        min-width: 80%;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        width: 100%;
        min-width: 25rem;
    }
`

export const ButtonsBox = styled(Box)`
    width: 100%;
    display: flex;
    gap: 0.5rem;
    padding: 1rem 0;

    align-items: center;
    justify-content: space-between;

    a {
        flex: 1;
        display: inherit;
    }

    button {
        flex: 1;
        font-size: 0.875rem;
        height: 2rem !important;
        width: 100%;
    }

    @media screen and (min-width: 42.5rem) {
        max-width: 20rem;
        // margin-top: -5% !important;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        button {
            min-width: 10rem;
        }
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
        position: relative;

        button {
            font-size: 1rem;
            height: 3rem !important;
            min-width: 12.5rem;
            width: 100%;
        }
    }
`
